function _extends(){return _extends=Object.assign?Object.assign.bind():function(n){for(var e=1;e<arguments.length;e++){var t=arguments[e];for(var r in t)({}).hasOwnProperty.call(t,r)&&(n[r]=t[r])}return n},_extends.apply(null,arguments)}import*as React from"react";import styled from"@emotion/styled";import{Button,Icon}from"@wp/src/components/common";import{css}from"@emotion/react";import{MenuItem}from"@wp/src/components/common";import{CardTitle}from"@wp/src/components/common/atoms";export const Content=styled.div`
  display: flex;
  min-width: 300px;
`;export const PortfolioActionButton=styled(Button)`
  ${props=>props.type==="text"?css`
          background-color: inherit !important;
          > span {
            color: ${props.theme.colors.defaultFontColor};
          }
        `:""}
  justify-content: center;
  width: fit-content !important;
  border: none;
`;export const DeletePortfolioButton=({disabled,...props})=>React.createElement(PortfolioActionButton,_extends({disabled:disabled},props));export const DeletePortfolioIcon=({disabled,...props})=>React.createElement(Icon,_extends({icon:"lucide:trash-2",className:`${disabled?"text-[#d9d9d9]":"text-danger"}`},props));export const EditPortfolioIcon=({disabled,...props})=>React.createElement(Icon,_extends({icon:"lucide:pencil",className:`${disabled?"text-[#d9d9d9]":"text-primary"}`},props));export const ViewPortfolioIcon=({disabled,...props})=>React.createElement(Icon,_extends({icon:"lucide:eye",className:`${disabled?"text-[#d9d9d9]":"text-primary"}`},props));export const PortfolioActionButtonContainer=styled.div`
  width: ${props=>props.isMenuItem?"100%":"initial"};

  ${props=>props.isMenuItem?css`
          & button,
          & > span > button {
            justify-content: flex-start;
            padding: 0;
            text-align: left;
          }
        `:""}
`;export const PortfoliosListTitle=styled(CardTitle)`
  display: inline-flex;
  align-items: center;
  align-content: center;
  justify-content: space-between;
  gap: 8px;
  width: 100%;
`;export const ActionMenuItem=styled(MenuItem)`
  > span {
    flex: unset;
  }
`;